import {NavigationHelpers} from '@react-navigation/native';
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../redux';
import {profileApplicationsItemSelector, profileApplicationsSelector} from '../../redux/selectors/profile';
import {getProfileApplications} from '../../redux/actions/profile';
import {LocalParamList} from '../components/tabBar/components/types';
import {NavigationRouteProps} from '../routing/model';
import {ProvidingListApplication} from '../models/api';
import {useDeviceSize, DeviceSize} from '../theme/helpers';

interface ResolverProps {
  navigation: NavigationHelpers<LocalParamList>;
  route: NavigationRouteProps<{'application-id': string}>;
  [extraProp: string]: any;
}

export const ProfileApplicationsResolver = (Component: React.FC<any>) => {
  return function Resolver(props: any) {
    const dispatch = useAppDispatch();
    const applications = useSelector(profileApplicationsSelector());

    useEffect(() => {
      if (!applications) {
        dispatch(getProfileApplications());
      }
    }, [applications]);

    // if (!applications) {
    //   return null;
    // }

    return React.createElement(Component, props);
  };
};

interface ComponentProps {
  application: ProvidingListApplication;
}

export const ProfileApplicationsItemResolver = (Component: React.FC<ComponentProps>) => {
  return ProfileApplicationsResolver(function Resolver(props: ResolverProps) {
    const applications = useSelector(profileApplicationsSelector());
    const deviceSize = useDeviceSize();
    const application = useSelector(profileApplicationsItemSelector(Number(props.route.params['application-id'])));

    useEffect(() => {
      // TODO: костыль: на мобиле зависает если переходить на страницу несуществующего элемента
      if (applications && !application && deviceSize === DeviceSize.desktop) {
        props.navigation.setParams({'application-id': ''});
        // props.navigation.navigate(Screens.ProfileApplications, {'application-id': ''});
      }
    }, [applications, application]);

    // if (!application) {
    //   return null;
    // }

    return React.createElement(Component, {...props, application: application} as ComponentProps & ResolverProps);
  });
};
